import { Link } from "react-router-dom";
import { FooterLinks } from "../components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-zinc-100 flex flex-col items-center justify-center px-4 text-center" data-testid="not-found-page">
      <img src={process.env.PUBLIC_URL + "/cehnura-mark.png"} alt="Cehnura" className="w-16 h-16 object-contain mb-6" />
      <h1 className="font-display text-6xl font-extrabold gold-text mb-2">404</h1>
      <p className="text-zinc-400 mb-8">Cette page n'existe pas ou a été déplacée.</p>
      <div className="flex gap-3">
        <Link to="/dashboard" data-testid="nf-dashboard-btn" className="h-11 px-6 rounded-xl gold-gradient text-black font-semibold flex items-center hover:opacity-90 transition-opacity">
          Retour à l'accueil
        </Link>
        <Link to="/login" data-testid="nf-login-btn" className="h-11 px-6 rounded-xl border border-zinc-700 text-zinc-200 font-semibold flex items-center hover:bg-zinc-900 transition-colors">
          Connexion
        </Link>
      </div>
      <FooterLinks />
    </div>
  );
}
